// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    margin: 0;
}

.div_header{
    background-color: var(--cor-roxoEscuro);
    color: var(--cor-branco);
    height: 3.43em;
    font-family: "Roboto";
    align-items: center;
    display: flex;
    justify-content: space-between;
}

.tittle{
    font-size: 2em;
    margin-left: 1em;
}

.div_header img{
    width: 9em;
}

.hora_data{
    margin-right: 2%;
    font-size: 18px;
    font-weight: bold;
}

`, "",{"version":3,"sources":["webpack://./src/cabecalho/Header.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,uCAAuC;IACvC,wBAAwB;IACxB,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB","sourcesContent":["*{\n    margin: 0;\n}\n\n.div_header{\n    background-color: var(--cor-roxoEscuro);\n    color: var(--cor-branco);\n    height: 3.43em;\n    font-family: \"Roboto\";\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n}\n\n.tittle{\n    font-size: 2em;\n    margin-left: 1em;\n}\n\n.div_header img{\n    width: 9em;\n}\n\n.hora_data{\n    margin-right: 2%;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
